// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3SEBB","head":"Table_head__2WV-9","col":"Table_col__2aHZZ"};